(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Shopify exposes no cart-API endpoint for discount codes. The only supported
  // mechanism is GET /discount/<code>, which sets the discount cookie; the cart
  // object then reflects it via cart.cart_level_discount_applications. So: hit
  // that URL, confirm against /cart.js, then re-render the drawer section.
  if (!customElements.get('loty-cart-discount')) {
    customElements.define(
      'loty-cart-discount',
      class LotyCartDiscount extends HTMLElement {
        connectedCallback() {
          if (this._bound) return;
          this._bound = true;

          this.input = this.querySelector('[data-discount-input]');
          this.button = this.querySelector('[data-discount-submit]');
          if (!this.input || !this.button) return;

          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            this.apply();
          });
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.apply();
            }
          });
        }

        get root() {
          return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        }

        setBusy(state) {
          this.button.setAttribute('aria-busy', state ? 'true' : 'false');
          this.input.disabled = !!state;
        }

        async apply() {
          const code = (this.input.value || '').trim();
          if (!code) return;

          this.setBusy(true);
          let applied = false;

          try {
            await fetch(this.root + 'discount/' + encodeURIComponent(code), {
              method: 'GET',
              credentials: 'same-origin',
            });

            const cartResponse = await fetch(this.root + 'cart.js', { credentials: 'same-origin' });
            const cart = await cartResponse.json();
            const wanted = code.toLowerCase();
            applied = (cart.discount_applications || []).some((discount) => {
              const title = (discount.title || '').toLowerCase();
              const key = (discount.key || '').toLowerCase();
              return title === wanted || key === wanted;
            });
          } catch (error) {
            applied = false;
          }

          // Re-rendering replaces this element, so re-read the fresh one afterwards.
          try {
            await this.refreshDrawer();
          } catch (error) {
            /* leave the current markup in place */
          }

          const fresh = document.querySelector('loty-cart-discount');
          if (fresh && fresh !== this) {
            if (!applied) fresh.showError(code);
          } else {
            this.setBusy(false);
            if (!applied) this.showError(code);
          }
        }

        showError(code) {
          const target = this.querySelector('[data-discount-error]');
          if (!target) return;
          target.textContent = this.dataset.errorText || '';
          target.hidden = !target.textContent;
          if (this.input && code) this.input.value = code;
        }

        async refreshDrawer() {
          const url = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
          const response = await fetch(url, { credentials: 'same-origin' });
          const sections = await response.json();
          const parse = (html, selector) =>
            new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

          const nextInner = parse(sections['cart-drawer'], '.drawer__inner');
          const currentInner = document.querySelector('#CartDrawer .drawer__inner');
          if (nextInner && currentInner) currentInner.innerHTML = nextInner.innerHTML;

          const nextBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
          const currentBubble = document.getElementById('cart-icon-bubble');
          if (nextBubble && currentBubble) currentBubble.innerHTML = nextBubble.innerHTML;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loty-ai-embed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function markLoaded(frame) {
      var wrap = frame.closest('[data-loty-aiembed]');
      if (wrap) wrap.classList.add('is-loaded');
    }

    function init(root) {
      (root || document).querySelectorAll('[data-loty-aiembed-frame]').forEach(function (frame) {
        if (frame.dataset.lotyBound) return;
        frame.dataset.lotyBound = 'true';
        frame.addEventListener('load', function () {
          markLoaded(frame);
        });
        // Cross-origin frames can fail silently; never leave the spinner up forever.
        setTimeout(function () {
          markLoaded(frame);
        }, 12000);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
    // Re-bind when the theme editor swaps the section in.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
